import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDTitleText } from '@facet-wealth/design';
import { InlineErrorAlert } from 'Components/ComponentLibrary/Atoms/Alerts/InlineAlert/InlineErrorAlert';
import {
  InfoBoxDetailList,
} from 'Views/Page/Content/Modal/Layouts/CreateYourPlanReviewStep/Layout/InfoSection/InfoBoxDetailList';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('details', {
    _component: () => InfoBoxDetailList,
  }, overrideReadOnly)
  .nameOverride('errorMessage', {
    _component: () => InlineErrorAlert,
  }, overrideReadOnly);

export default metaOverrideSet;
